<template>
  <div id="marketingTable">
    <el-table
      :row-style="{ height: '25px' }"
      :cell-style="{ padding: '0px' }"
      :data="tableData"
      stripe
      style="width: 100%"
      :header-cell-style="{
        background: '#F3F3F3',
        color: '#333',
        height: '41px',
        padding: '0px'
      }"
    >
      <el-table-column type="index" width="50" label="序号" align="left" />
      <el-table-column v-for="item in tableheader" :key="item.index" :label="item.label" :prop="item.prop" :align="changeALign(item.align)">
        <template slot-scope="scope">
          <el-button type="primary" plain v-if="item.isDownload" size="mini" class="downBtn" @click="download(scope.row[item.prop])">
            <i class="el-icon-download" style="margin-right: 5px" />下载所有附件</el-button
          >
          <span v-else :style="{ color: item.color ? item.color : '#999' }">
            {{ item.isFormatNumber ? num_formatter(scope.row[item.prop]) : scope.row[item.prop] }}
          </span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import utils from '@/utils.js'
import req from '@/request.js'

export default {
  props: ['tableheader', 'tableData'],
  data() {
    return {}
  },
  methods: {
    changeALign(align) {
      if (align) {
        return align
      } else {
        return 'left'
      }
    },
    // 下载
    download(item) {
      if (item) {
        const arr = JSON.parse(item)
        if (arr.length) {
          arr.forEach((e) => {
            if (e.response && e.response.fileId) {
              req.download('${portal}/system/file/v1/downloadFile?fileId=' + e.response.fileId)
            }
          })
        }
      }
    },
    // 千分位
    num_formatter(cellValue) {
      if (cellValue || cellValue == 0) {
        return utils.dataTransform(String(cellValue))
      }
    }
  },
  mounted() {}
}
</script>

<style scoped>
.el-button--primary.is-plain {
  background-color: #fff !important;
  color: #409eff !important;
}
.el-button--primary.is-plain:hover {
  background-color: #409eff;
  color: #fff;
}
.el-table__header-wrapper tbody td,
.el-table__footer-wrapper tbody td {
  color: red !important;
  background-color: white !important;
}
.dialog-header-title {
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 10px;
}

.dialog-header-title > span {
  border-left: 3px solid #2761ff;
  font-weight: 700;
  font-size: 14px;
  padding-left: 10px;
  color: #666;
}

#marketingTable .el-table__row > td {
  border: none;
}
#marketingTable .el-table::before {
  height: 0px;
}
#marketingTable .el-table__header-wrapper tbody td,
.el-table__footer-wrapper tbody td {
  color: #d00101;
  background-color: white;
  border-bottom: none;
}
#marketingTable .riskContent {
  padding-left: 20px;
  padding-right: 20px;
}
#marketingTable .riskContent p {
  font-size: 14px;
  color: #333333;
  margin-bottom: 10px;
}
#marketingTable .riskTitle {
  color: rgba(102, 102, 102, 100);
  font-size: 18px;
  font-weight: bold;
}
#marketingTable .riskFrom {
  font-size: 14px;
  color: #666666;
  margin-bottom: 25px;
}
#marketingTable .riskInfo p {
  color: rgba(51, 51, 51, 100);
  font-size: 14px;
  margin-bottom: 5px;
}
#marketingTable .blueTit {
  margin-top: 25px;
  margin-bottom: 17px;
  font-size: 16px;
  color: #666666;
  font-weight: bold;
  padding-left: 14px;
  line-height: 20px;
  border-left: 5px solid #4188f0;
}
#marketingTable .riskJoin h4 {
  margin-top: 20px;
  color: rgba(102, 102, 102, 100);
  font-size: 14px;
  font-weight: bolder;
}
</style>
